import { Obj } from 'app/tools/general.types';
import mapValuesDeep from 'map-values-deep';

export const GENERAL_MAX_LENGTH = 100;
export const NAME_MAX_LENGTH = 40;

export const EMAIL_MAX_LENGTH = 254;

// eslint-disable-next-line no-control-regex
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const PW_MIN_LENGTH = 8;
export const PW_MAX_LENGTH = 40;
// password must contain at least one of each: uppercase, lowercase, digit
export const PW_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).*$/;
const ONE_UPPER = /^(?=.*?[A-Z]).*$/;
const ONE_LOWER = /^(?=.*?[a-z]).*$/;
const ONE_DIGIT = /^(?=.*?[0-9]).*$/;

/** Matches phone numbers of many different kinds. See https://stackoverflow.com/a/20971688/6283495 */
export const PHONE_REGEX =
  // eslint-disable-next-line no-useless-escape
  /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;

type RuleObj<N extends string> = {
  [x in N]: {
    value: number;
    message: string;
  };
};

export const minLengthRule = (
  minLength: number
): RuleObj<'minLength'> => ({
  minLength: {
    value: minLength,
    message: `Must be ${minLength} or more characters long`,
  },
});

export const maxLengthRule = (
  maxLength: number
): RuleObj<'maxLength'> => ({
  maxLength: {
    value: maxLength,
    message: `Must be less than ${maxLength} characters long`,
  },
});

export const getFieldErrorMessages = (
  errorObj?: Obj | unknown[]
): string => {
  const messages: string[] = [];

  mapValuesDeep(errorObj, (v, k) => {
    if (k === 'message' && typeof v === 'string') {
      messages.push(v);
    }
  });

  return messages.join('<br>');
};

const tickOrCrossStyle =
  "font-family: 'Segoe UI Symbol'; display: inline-block; width: 0.85em";
const pwMsgPart = (pass: boolean, msg: string) =>
  `<span ${
    pass ? 'style="color: #31AD31"' : ''
  }><span style="${tickOrCrossStyle}">${
    pass ? '✔' : '<b>✗</b>'
  }</span> ${msg}</span>`;

export const NAME_RULES = maxLengthRule(NAME_MAX_LENGTH);

export const EMAIL_RULES = {
  ...maxLengthRule(EMAIL_MAX_LENGTH),
  pattern: {
    value: EMAIL_REGEX,
    message: 'Please enter a valid email address',
  },
};

export const PW_RULES = {
  required: 'Required',
  ...maxLengthRule(PW_MAX_LENGTH),
  validate: {
    pattern: (value: string): true | string =>
      (PW_REGEX.test(value) && value.length >= PW_MIN_LENGTH) ||
      `Password must include:
      <br>
      ${pwMsgPart(
        value.length >= PW_MIN_LENGTH,
        'eight or more characters'
      )}
      <br>
      ${pwMsgPart(ONE_UPPER.test(value), 'one upper-case letter')}
      <br>
      ${pwMsgPart(ONE_LOWER.test(value), 'one lower-case letter')}
      <br>
      ${pwMsgPart(ONE_DIGIT.test(value), 'one digit')}`,
  },
};

export const PHONE_RULES = {
  validate: {
    pattern: (value: string): true | string =>
      PHONE_REGEX.test(value) || 'Please enter a valid phone number',
  },
};
